import { render, staticRenderFns } from "./ClosedSolutionDetails.vue?vue&type=template&id=01f268a6&scoped=true&"
import script from "./ClosedSolutionDetails.vue?vue&type=script&lang=js&"
export * from "./ClosedSolutionDetails.vue?vue&type=script&lang=js&"
import style0 from "./ClosedSolutionDetails.vue?vue&type=style&index=0&id=01f268a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f268a6",
  null
  
)

export default component.exports